module.exports = __webpack_public_path__ + "ba81b24c06e2e0eac1e219405b33766b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/layer/icon-ext.png
// module id = 1044
// module chunks = 73